const carouselItems = [
  {
    title: '暑期档影视盛宴',
    desc: '暑期档热门影视一站式聚合，院线大片、热播剧集、经典动漫尽在四虎影视大全，这个夏天让你的观影清单不再空虚。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20marathon%20theme%20with%20film%20strips%20and%20warm%20golden%20sunset%20lighting%2C%20movie%20theater%20atmosphere%2C%20dramatic%20spotlight%20rays%2C%20luxurious%20dark%20and%20gold%20color%20scheme%2C%20no%20text%2C%20epic%20cinematic%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '限时专题',
    badge: '热门',
  },
  {
    title: '经典港片修复计划',
    desc: '四虎影视大全倾力打造经典港片高清修复计划，首批50部周星驰、成龙、周润发代表作已上线，重温黄金时代的港片情怀。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgic%20theme%20with%20vintage%20film%20poster%20aesthetic%2C%20neon%20cityscape%20at%20night%2C%20warm%20nostalgic%20color%20palette%20of%20amber%20and%20crimson%2C%20no%20text%2C%20retro%20cinematic%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '特别企划',
    badge: '新上线',
  },
  {
    title: '高分纪录片精选',
    desc: '从自然探索到人文历史，从科技前沿到社会观察，四虎影视大全精选BBC、Discovery高分纪录片，带你看见世界的辽阔与精妙。',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20style%20cinematic%20landscape%20showing%20vast%20nature%20and%20wildlife%2C%20golden%20hour%20lighting%20over%20mountains%20and%20oceans%2C%20epic%20scale%20with%20warm%20earthy%20tones%2C%20no%20text%2C%20awe%20inspiring%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '知识盛宴',
    badge: '推荐',
  },
  {
    title: '周末追剧指南',
    desc: '周末不知道看什么？四虎影视大全编辑部每周精选高分好剧，从悬疑到治愈、从热血到温情，总有一部适合你这个周末。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20cinema%20setup%20with%20warm%20ambient%20lighting%2C%20soft%20blanket%20and%20popcorn%20on%20sofa%2C%20large%20screen%20glowing%20in%20dark%20room%2C%20comfortable%20and%20inviting%20atmosphere%2C%20no%20text%2C%20warm%20cinematic%20mood&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '每周精选',
    badge: '周更',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-500/10 text-secondary-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-focus-2-line text-xs"></i>
            专题策划
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm">编辑部精心策划的深度影视专题</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-300/40 hover:border-background-400/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-300/30">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/30 to-transparent"></div>
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="px-2 py-1 rounded-md bg-primary-500/90 text-foreground-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="px-2 py-1 rounded-md bg-accent-500/90 text-foreground-50 text-xs font-medium whitespace-nowrap">
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-50 mb-1">
                  {item.title}
                </h3>
                <p className="text-foreground-300 text-xs md:text-sm line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}